import moment from "moment";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { StudentManagementCss, DivTickets } from "./styles";
import { getFilterTickets, getTicketsTeachers } from "../../store/middleware";
import PlaceholderText from "../../components/Placeholder/PlaceholderText";

function TicketStudent({ id }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { ticketsTeachers } = useSelector((state) => state.companyManagerReducer);

  const handleTicketDetail = (id) => {
    dispatch(
      getFilterTickets({
        id,
        requester: "",
        role: "",
        ticketTypeId: "",
        ticketSubTypeId: "",
        createdAt: "",
        status: "",
        creatorUserId: "",
        pageNumber: 1,
        pageSize: 10,
      }),
    );
  };

  const getData = async () => {
    await dispatch(getTicketsTeachers(id));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <StudentManagementCss>
        <DivTickets>
          {ticketsTeachers?.length > 0 ? (
            ticketsTeachers?.map((ticket) => (
              <div key={ticket.id} className="boxRow">
                <div className="item">
                  <div className="boxColumn">
                    <label>{t("TICKET_ID")}</label>
                    <span>{ticket.id}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("STATUS")}</label>
                    <span
                      className={
                        ticket.status === "closed"
                          ? "closed"
                          : ticket.status === "open"
                          ? "open"
                          : ticket.status === "inProgress"
                          ? "progress"
                          : "cancelled"
                      }
                    >
                      {ticket.status === "inProgress" ? "In progress" : ticket.status}
                    </span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("TITLE")}</label>
                    <span>{ticket.title}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("TYPE")}</label>
                    <span>{ticket.ticketType ? ticket.ticketType.nameEnglish : ""}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("SUBTYPE")}</label>
                    <span>{ticket.ticketSubType ? ticket.ticketSubType.nameEnglish : ""}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("OPEN_DATE")}</label>
                    <span>{moment(ticket.createdAt).format("YYYY/MM/DD • hh:mm")}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>Last Interaction</label>
                    <span>{moment(ticket.updatedAt).format("YYYY/MM/DD • hh:mm")}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <div className="status">
                      <Link to={"/customer-service/ticketDetail"}>
                        <button onClick={() => handleTicketDetail(ticket.id)}>
                          {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <PlaceholderText label="No results" />
          )}
        </DivTickets>
      </StudentManagementCss>
    </div>
  );
}

export default TicketStudent;
